import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderActsGql } from '../../workOrderQueries';

export const useWorkOrderActs = ({
    workOrderId,
    constructionTypeId,
    withEffect = true,
}: {
    workOrderId?: number;
    constructionTypeId?: number;
    withEffect?: boolean;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(() => {
        if (workOrderId && constructionTypeId) {
            return {
                workOrderId,
                constructionTypeId,
            };
        }

        return undefined;
    }, [workOrderId, constructionTypeId]);

    const [data, , , request] = useRequest({
        requestId: 'workOrderActs',
        query: uerWorkOrderActsGql,
        variables,
        withEffect: !!variables && withEffect,
    });

    const refreshActs = useCallback(() => {
        dispatch(request(variables));
    }, [dispatch, request, variables]);

    return {
        acts: data?.uerWorkOrderActs?.items,
        refreshActs,
    };
};
